
import { Component, Renderer2, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { SiriusBaseComponent } from 'sirius-framework';
import { FaqContent } from '../shared/models/menuItem';
import { CommonService } from '../../app/shared/service/shared.service';

declare const $: any;

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.css']
})
export class FaqComponent extends SiriusBaseComponent<any> {
    pageTitle: string = "Sık Sorulan Sorular";
    sssContent: Array<FaqContent>;
    @ViewChildren('elementTitles') elementTitles: QueryList<ElementRef>;

    constructor(private renderer: Renderer2, private commonService: CommonService) {
      super();  
      this.commonService.urlService();  
  }

    OnInit() {

        let faqContent = this.resourceService.getResource("yediEminFaqContent");
        this.sssContent = new Array<FaqContent>();
        let questionAndAnswers = faqContent.split('#');
        for (var i = 0; i < questionAndAnswers.length; i++) {
            let faqItem = new FaqContent();
            let singleQa = questionAndAnswers[i].split('|');
            faqItem.question = singleQa[0];
            faqItem.answer = singleQa[1];
            this.sssContent.push(faqItem);
        } 
  }

  elementTitleClicked(i: number) {
    var elementList = this.elementTitles.toArray();
    for (let j = 0; j < elementList.length; j++) {
      if (j == i) {
        if (elementList[j].nativeElement.children[0].classList.contains("open")) {
          this.renderer.removeClass(elementList[j].nativeElement.children[0], 'open');
          this.renderer.removeClass(elementList[j].nativeElement.children[1], 'show');
        }
        else {
          this.renderer.addClass(elementList[j].nativeElement.children[0], 'open');
          this.renderer.addClass(elementList[j].nativeElement.children[1], 'show');
        }
      }
      else {
        this.renderer.removeClass(elementList[j].nativeElement.children[0], 'open');
        this.renderer.removeClass(elementList[j].nativeElement.children[1], 'show');
      }
    }
    $(document).ready(() => {
      $(".list-group").animate({ scrollTop: $('#elementTitleOfSearchResult' + i).height() * i }, 600);
    });
  }
}
